import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './style.scss';
import { FadeInImage } from '../../../../components/FadeInImage';
import { getRegion } from '../../../../utils/Region';
import { clearKeywordSearch } from '../../../NewSearchPage/redux/actions/searchActions';
import { useNavigate } from 'react-router-dom';

export const SearchItem = ({ isActive }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    search_menu_option_button_popularSearches,
    search_combo_icon_placeholder_search,
  } = useSelector(state => state.asset);
  const redirectToSearch = () => {
    //Accion para limpiar la keyword
    dispatch(clearKeywordSearch());
    navigate(`/${getRegion()}/search`);
  };
  const searchIcon = isActive
    ? search_combo_icon_placeholder_search
    : search_menu_option_button_popularSearches;

  return (
    <li
      className={`search-item ${isActive ? 'active-icon' : ''}`}
      onClick={redirectToSearch}
    >
      <FadeInImage
        imageSrc={searchIcon}
        imageAlt={'glass'}
        classNames={['search-item__icon']}
        width="21"
        height="21"
      />
    </li>
  );
};
